<template>
    <div>
        <div>
            <a-modal
                :visible="visible"
                @cancel="handleCancel"
                :footer="null"
                :width="900"
            >
                <img :src="showImg" alt="" width="100%">
            </a-modal>
        </div>
        <div class="top-img">
            <img src="../../static/images/u389.png" alt="">
        </div>
        <div class="breadcrumb-div">
            <div class="FL">
                <img src="../../static/images/u177.png" alt="" class="breadcrumb-img">
            </div>
            <div class="FL breadcrumb-title">
                {{ $t('lang.position') }}：
            </div>
            <div class="FL">
                <a-breadcrumb class="breadcrumb-main">
                    <a-breadcrumb-item><a href="/">{{ $t('lang.index1') }}</a></a-breadcrumb-item>
                    <a-breadcrumb-item><span @click="goBack" class="cursor-pointer">{{ $t('lang.Product') }}</span>
                    </a-breadcrumb-item>
                </a-breadcrumb>
            </div>
        </div>
        <div class="main-div MT30">
            <div class="MT30">
                <div class="FL MT30">
                    <navComponent/>
                </div>
                <div class="FR" style="width: 1080px;">
                    <a-row>
                        <a-col :span="12">
                            <img :src="productInfo.image[0].url" @click="show(productInfo.image[0].url)"
                                 class="InfoImg CursorPointer" :alt="productInfo.name">
                        </a-col>
                        <a-col :span="11">
                            <p class="NameType">{{ productInfo.name }}</p>
                            <div class="Line"></div>
                            <div class="TextAlign MarginAuto Color1 InfoSg BGC-Main">
                                <div class="Nav2">{{ $t('lang.Assurance') }}</div>
                            </div>
                            <p class="pInfo">{{ $t('lang.number') }}：{{ productInfo.number }} </p>
                            <p class="pInfo">{{ $t('lang.model') }}：{{ productInfo.model }}</p>
                            <p class="pInfo">{{ $t('lang.price') }}：{{ productInfo.price }}</p>
                            <p class="pInfo">{{ $t('lang.picture') }}：</p>
                            <div>
                                <img :src="item.url" @click="show(item.url)" class="SmallImg CursorPointer"
                                     :alt="productInfo.name" v-for="(item,i) in productInfo.image" :key="i">
                            </div>
                        </a-col>
                    </a-row>
                    <div class="InfoDiv">
                        <div class="BGC-Main InfoTopDiv">
                            <button type="button" class="InfoBut InfoButDiv" v-bind:class="{SelectBut:SelectDiv===1}"
                                    @click="selectCont(1)">{{ $t('lang.Description') }}
                            </button>
                            <button type="button" class="InfoBut InfoButDiv" v-bind:class="{SelectBut:SelectDiv===2}"
                                    @click="selectCont(2)">{{ $t('lang.technical') }}
                            </button>
                            <!--                            <button type="button" class="InfoBut InfoButDiv" v-bind:class="{SelectBut:SelectDiv===3}"-->
                            <!--                                    @click="selectCont(3)">订货型号-->
                            <!--                            </button>-->
                        </div>
                        <div class="P20" v-if="SelectDiv===1" v-html="productInfo.summary"></div>
                        <div class="P20" v-if="SelectDiv===2" v-html="productInfo.techParam"></div>
                        <!--                        <div class="P20" v-if="SelectDiv===3" v-html="productInfo.size"></div>-->
                    </div>
                </div>
                <div class="ClearFloat"></div>
            </div>
        </div>
    </div>
</template>

<script>
import navComponent from "@/components/navcomponents";
// import goodsList from "../../static/data/product.json";
import {get} from "@/utils";

export default {
    name: "GoodInfo",
    components: {
        navComponent
    },

    data() {
        return {
            visible: false,
            id: 1,
            goodsList: [],
            SelectDiv: 1,
            src: '',
            showImg: '',
            productInfo: {
                name: undefined,
                main: undefined,
                parameter: undefined,
                size: undefined,
                Introduction: undefined,
                number: undefined,
                model: undefined,
                price: undefined
            },
        }
    },
    mounted() {
        const box = document.getElementsByTagName('html');
        box[0].scrollTop = 0;
        // this.id = Number(this.$route.query.id);
        this.id = parseFloat(this.$route.params.id)
        get('product/getProduct', {
            id: this.id
        }).then(res => {
            if (!res.data || res.data.id === 0) {
                this.$router.push({path: '/404'}).then(() => {
                });
            }
            this.productInfo = res.data;
            document.title = this.productInfo.name
        }).catch(() => {
        })
        // this.goodsList = goodsList.product;
        // for (const a of this.goodsList) {
        //     if (a.id === Number(this.id)) {
        //         this.productInfo = a;
        //         const src1 = this.productInfo.src1.slice(20, -4);
        //         this.productInfo.newSrc1 = require('../../static/images/' + src1 + '.jpg');
        //         this.src = this.productInfo.newSrc1;
        //         const src2 = this.productInfo.src2.slice(20, -4);
        //         this.productInfo.newSrc2 = require('../../static/images/' + src2 + '.jpg');
        //         const src3 = this.productInfo.src3.slice(20, -4);
        //         this.productInfo.newSrc3 = require('../../static/images/' + src3 + '.jpg');
        //         const src4 = this.productInfo.src4.slice(20, -4);
        //         this.productInfo.newSrc4 = require('../../static/images/' + src4 + '.jpg');
        //         this.productInfo.Introduction = this.productInfo.Introduction.replace('../../static/images/', process.env.BASE_URL);
        //         this.productInfo.parameter = this.productInfo.parameter.replace('../../static/images/', process.env.BASE_URL);
        //         this.productInfo.size = this.productInfo.size.replace('../../static/images/', process.env.BASE_URL);
        //     }
        // }
    },
    methods: {
        selectCont(i) {
            this.SelectDiv = i;
        },
        // selectSrc(i) {
        //     if (i === 1) {
        //         this.src = this.productInfo.newSrc1
        //     } else if (i === 2) {
        //         this.src = this.productInfo.newSrc2
        //     } else if (i === 3) {
        //         this.src = this.productInfo.newSrc3
        //     } else if (i === 4) {
        //         this.src = this.productInfo.newSrc4
        //     }
        // },
        goBack() {
            history.go(-1)
        },
        handleCancel() {
            this.visible = false;
        },
        show(e) {
            this.showImg = e;
            this.visible = true;
        },
    },
}
</script>

<style scoped>
.InfoImg {
    width: 460px;
    max-height: 460px;
}

button {
    padding: 0;
    margin: 0;
    outline: none;
    background: transparent;
    border: none;
}

.CursorPointer {
    cursor: pointer;
}

.SelectBut {
    color: white !important;
    background: #ffb700 !important;
}

.NameType {
    font-weight: 700;
    font-style: normal;
    font-size: 24px;
}

.Line {
    border: 1px solid #199ED8;
    margin-top: 15px;
}

.BGC-Main {
    background-color: #199ED8;
}

.InfoButDiv:hover {
    color: white !important;
    background: #ffb700 !important;
}

.Nav2 {
    transform: skewX(45deg);
}

.InfoSg {
    font-size: 16px;
    width: 200px;
    margin-top: 15px;
    transform: skewX(-45deg);
}

.Color1 {
    color: #FFFFFF;
}

.MarginAuto {
    margin: 0 auto;
}

.TextAlign {
    text-align: center;
}

.InfoSg {
    font-size: 16px;
    width: 200px;
    margin-top: 15px;
    transform: skewX(-45deg);
}

.SmallImg {
    width: 90px;
    margin: 5px 13px;
}

.pInfo {
    line-height: 62px;
    font-size: 20px;
}

.InfoDiv {
    width: 95%;
    min-height: 500px;
    border: 1px solid #199ED8;
    margin-top: 55px;
    border-radius: 15px 15px 0 0;
}

.InfoTopDiv {
    border-radius: 15px 15px 0 0;
    width: 100%;
    height: 55px;
}

.InfoBut {
    background: #fffbfb;
    padding: 0 20px;
    height: 40px;
    margin-top: 7px;
    margin-left: 49px;
    border-radius: 20px;
    letter-spacing: 2px;
}


.P20 {
    padding: 20px;
}

</style>
